import React from 'react';
import { Modal, Button, notification } from 'tea-component';
import './index.scss';
import {
  groupDel,
} from '@/pages/intelligence/services/following';
import { useIntl } from 'umi';

const DeleteGroup = (porps: any) => {
  const { visible, onConfirm, setDeleteGroup, mainSegment, checkList, DEFAULT_GROUPNAME } = porps;
  const { formatMessage } = useIntl(); // 中英切换方法

  const handleDelGroup = async () => {
    setDeleteGroup && setDeleteGroup();
    try {
      const res = await groupDel({
        entity_type: mainSegment,
        entity_names: checkList,
      })
      if (res?.code === 0 || res?.code === 200) {
        notification.success({
          description: formatMessage({ id: 'dbi_success_delete' }),
          duration: 3000,
        });
        if (onConfirm instanceof Function) {
          onConfirm();
        }
      } else {
        notification.error({
          duration: 3000,
          description: formatMessage({ id: 'dbi_group_delete_failed_again' }),
        });
      }
    } catch (err) {
      notification.error({
        duration: 3000,
        description: formatMessage({ id: 'dbi_group_delete_failed_again' }),
      });
    }
  }

  return (
    <Modal
      className="dbi-delete-group"
      visible={visible}
      size={500}
      onClose={() => setDeleteGroup && setDeleteGroup()}
    >
      <Modal.Body>
        <div className="dbi-delete-group-title">
          {formatMessage({ id: 'dbi_want_delete_this_group' })}
        </div>
        <div className="dbi-delete-group-content">
          {formatMessage({ id: 'dbi_games_group_will_move_to' }) + ' ' + DEFAULT_GROUPNAME + '.'}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button
          type="primary"
          onClick={handleDelGroup}
        >
          {formatMessage({ id: 'dbi_confirm' })}
        </Button>
        <Button
          type="weak"
          onClick={() => {
            setDeleteGroup && setDeleteGroup();
          }}
        >
          {formatMessage({ id: 'dbi_cancel' })}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteGroup;
